import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RoleFiltering, RoleAddEdit } from './Pages';

export const RoleRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={RoleFiltering} />
        <Route exact path={`${match.path}/AddEdit`} component={RoleAddEdit} />
    </Fragment>
)